import React from 'react';
import BouncingDots from '../../components/BouncingDots';

import { ReactComponent as Check } from '../../assets/ic_24_check.svg';
import Character from './qv-loading.png';

import Styles from '../../Loading.module.scss';

const ListItem = ({ text }) => (
  <div className={Styles.ListItem}>
    <div className={Styles.Oval}>
      <Check />
    </div>
    {text}
  </div>
);

const QvPage = ({ theme_style }) => {
  return (
    <div className={Styles.Loading} style={theme_style}>
      <div
        className="d-flex justify-center"
        style={{ margin: '40px 0 16px 0' }}
      >
        <img
          src={Character}
          alt="한국의약품관리원"
          style={{
            width: '200px',
            height: '200px',
            objectFit: 'cover',
            borderRadius: '50%',
            backgroundColor: 'transparent',
          }}
        />
      </div>
      <div className="d-flex flex-column justify-center align-items-center">
        <div>한국의약품관리원 상담 화면으로 연결 중입니다.</div>
        <div>잠시만 기다려 주세요.</div>
      </div>

      <div
        className="d-flex justify-center"
        style={{ margin: '11px 0 27px 0' }}
      >
        <BouncingDots />
      </div>

      <div className={Styles.List}>
        <ListItem text="대기 하지 않고" />
        <ListItem text="눈으로 보면서" />
        <ListItem text="간편하게 처리" />
      </div>

      <div className={Styles.Footer}>
        <div>이용 중 데이터 요금이 부과 될수 있습니다.</div>
        <div>연결 후 화면에서 선택해주세요.</div>
      </div>
    </div>
  );
};

QvPage.propTypes = {};

export default QvPage;
